import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface IProductViewDeliveryModalDataContent extends Catalog.IBlockData<IProductViewDeliveryModalDataContent> { }
export interface IProductViewDeliveryModalDataContent {
    copy: string;
}
export const DELIVERY_MODAL_ID = 'deliveryModal';

@ICmsComponent<ProductViewDeliveryModalComponent>({
    id: 'product-view-delivery',
    block: {
        url: 'product-view-delivery',
        autoload: 'prerender'
    },
    onDemandOnly: true,
    name: 'Product Delivery Block',
    description: 'Product Delivery Block',
    fields: [
        <NICmsContentField.IField>{
            key: 'copy',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy',
            required: true
        }
    ]
})
@Component({
    selector: 'product-view-delivery-modal',
    templateUrl: './product-view-delivery-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsClientModule],
})
export class ProductViewDeliveryModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IProductViewDeliveryModalDataContent;

    @Input()
    variant?: string;
}
